import { render, staticRenderFns } from "./community-change.vue?vue&type=template&id=4f1c455a&scoped=true&"
import script from "./community-change.vue?vue&type=script&lang=js&"
export * from "./community-change.vue?vue&type=script&lang=js&"
import style0 from "./community-change.vue?vue&type=style&index=0&id=4f1c455a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1c455a",
  null
  
)

export default component.exports